export const SOLID = 'solid'
export const DOTS = 'dots'
export const DASHES = 'dashes'
export const DOTS_WITH_DASHES = 'dotsWithDashes'

export const strokeModels = Object.freeze({
    solid: {
        key: SOLID,
        label: 'Solid',
        value: '0'
    },
    dots: {
        key: DOTS,
        label: 'Dots',
        value: '2'
    },
    dashes: {
        key: DASHES,
        label: 'Dashes',
        value: '6 2'
    },
    dotsWithDashes: {
        key: DOTS_WITH_DASHES,
        label: 'Dots and dashes',
        value: '6 2 2 2'
    }
})

export const strokeModelsList = Object.freeze(Object.values(strokeModels))
